import React, { ReactNode } from 'react';
import { InjectedIntl, injectIntl } from 'react-intl';
import { Field, FieldProps } from 'formik';
import ValueFormatters from './valueFormatters';
import InputField from '../components/InputField';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import { ValidatorRule } from '../validator/validatorRule.constants';
import { IErrorMessage } from '../components/errorMessage/errorMessage.type';
import ValidationErrors from './validationErrors';
import { BaseValidator } from '../validator/baseValidator';

interface IJobTitleFieldProps {
    autoFocus?: boolean;
    intl: InjectedIntl;
    value?: string;
    required?: boolean;
    validatorRules?: ValidatorRule[];
}

class JobTitleField extends React.Component<IJobTitleFieldProps> {
    private readonly ID: string;
    private readonly LABEL_ID: string;
    private readonly ERROR_REQUIRED_ID: string;
    private readonly MAX_LENGTH: number;

    private jobTileValidator: BaseValidator;

    constructor(props: IJobTitleFieldProps) {
        super(props);

        this.ID = `positionName`;
        this.LABEL_ID = 'label.position_name';
        this.ERROR_REQUIRED_ID = 'error.position_name_required';
        this.MAX_LENGTH = 85;

        this.validate = this.validate.bind(this);
        this.renderInputField = this.renderInputField.bind(this);
        const { validatorRules = [] } = props;
        this.jobTileValidator = new BaseValidator(validatorRules);
    }

    private validate(value: string): IErrorMessage {
        const { intl, required, validatorRules = [] } = this.props;

        if (!value && required) {
            return intl.formatMessage(
                TranslationHelpers.getMessageDescriptor(this.ERROR_REQUIRED_ID),
            );
        }

        if (value && value.length > this.MAX_LENGTH) {
            return ValidationErrors.fieldTooLongMessageProps(this.MAX_LENGTH);
        }

        let errorMessage: IErrorMessage = '';
        if (value && validatorRules.length > 0) {
            const err = this.jobTileValidator.validate(value, this.LABEL_ID);
            if (err !== null) {
                errorMessage = err.message;
            }
        }

        return errorMessage;
    }

    public render() {
        return (
            <Field name={this.ID} validate={this.validate} render={this.renderInputField}></Field>
        );
    }

    private renderInputField({
        form: { touched, errors, setFieldValue, handleBlur },
    }: FieldProps): ReactNode {
        const { autoFocus, intl, value, required } = this.props;
        const isTouched = touched && touched[this.ID];
        const errorMessage = isTouched && errors && errors[this.ID] ? errors[this.ID] : undefined;
        const onBlur = (event: React.FocusEvent<any>) => {
            setFieldValue(this.ID, ValueFormatters.trimExtraSpaces(event.target.value));
            handleBlur(event);
        };

        return (
            <InputField
                autoComplete="organization-title"
                labelMessage={TranslationHelpers.getMessageDescriptor(this.LABEL_ID)}
                type="text"
                id={this.ID}
                name={this.ID}
                value={value}
                error={errorMessage}
                autoFocus={autoFocus}
                required={required}
                onBlur={onBlur}
            />
        );
    }
}

export default injectIntl(JobTitleField);
